var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-card", {
    staticClass: "empty-card",
    attrs: { "card-header": "" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm._f("fullName")(_vm.details))),
            ]),
            _vm._v("\n    " + _vm._s(" ") + "\n    "),
            _vm._v(" "),
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("client-profile.actions.profileCreatedOn", {
                    date: _vm.$options.filters.momentLocal(
                      _vm.createdAt,
                      "MMM. DD, YYYY"
                    ),
                    time: _vm.$options.filters.momentLocal(_vm.createdAt, "LT"),
                  })
                ),
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }